import { combineReducers } from 'redux';
import types from './types';

const pageNumber = (
  state: any = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: number;
  }
) => {
  switch (type) {
    case types.PAGE_NUMBER:
      return payload;
    default:
      return state;
  }
};

const pageSize = (
  state: any = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: number;
  }
) => {
  switch (type) {
    case types.PAGE_SIZE:
      return payload;
    default:
      return state;
  }
};

const totalElements = (
  state: any = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: number;
  }
) => {
  switch (type) {
    case types.TOTAL_ELEMENTS:
      return payload;
    default:
      return state;
  }
};

const totalPages = (
  state: any = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: number;
  }
) => {
  switch (type) {
    case types.TOTAL_PAGES:
      return payload;
    default:
      return state;
  }
};

const paginationReducer = combineReducers({
  pageNumber,
  pageSize,
  totalElements,
  totalPages
});

export default paginationReducer;
